import { App } from '@ps20-frontend/frontend-models';
import { v1 as uuidv1 } from 'uuid';
import { StatePreV20, StateV20 } from './20_migrate_hoeherwertigerhausrat_files.interface';

export const migrateHoeherwertigerHausrat = (
  previousState: StatePreV20,
  version: number,
): StateV20 => {
  return {
    ...previousState,
    version,
    produkte: previousState.produkte.map(product => {
      if (product.appId === App.VHV) {
        if (product.einbruchMeldeanlage) {
          product.einbruchMeldeanlage.files = [];
        }
        if (product.mechanischeSicherungen) {
          product.mechanischeSicherungen.files = [];
        }
        if (product.tresor?.eintraege) {
          product.tresor.eintraege.forEach(eintrag => {
            eintrag.files = [];
            eintrag.tresorId = uuidv1();
          });
        }
        product.filesToDelete = [];
      }
      return product;
    }),
  };
};
